<template>
  <main id="app">
    <div class="wrapper">
      <div class="loading-wrap" v-if="isLoading">
        <md-progress-spinner
          :md-diameter="100"
          :md-stroke="10"
          class="md-accent"
          md-mode="indeterminate"
        ></md-progress-spinner>
        <!-- {{refCount}} -->
      </div>
      <router-view></router-view>
    </div>
  </main>
</template>

<script>
import axios from "axios";
// import Smartlook from "smartlook";

export default {
  name: "app",
  data() {
    return {
      refCount: 0,
      isLoading: false,
    };
  },
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.isLoading = this.refCount > 0;
      }
    },
  },

  mounted() {
   
  },

  created() {
    axios.interceptors.request.use(
      (config) => {
        this.setLoading(true);
        return config;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.setLoading(false);
        return response;
      },
      (error) => {
        this.setLoading(false);
        return Promise.reject(error);
      }
    );
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  margin-top: 0;
}
.loading-wrap {
  position: absolute;
  /* top: 50%; */
  /* left: 47%; */
  width: 100%;
  background: #2929293d;
  height: 100%;
  z-index: 1000;
  text-align: center;
}
.md-progress-spinner {
  top: 40%;
}
:root {
  --md-theme-default-primary: #448aff;
  --md-theme-default-accent: #ff607f;
  --md-theme-default-theme: "light";
}
.md-accent {
  z-index: 1000;
}
@import "~bootstrap/dist/css/bootstrap.css";
.btn-green {
  background-color: #4bbe56 !important;
  box-shadow: 2px 2px 5px 0px #5ef16b;
  color: white !important;
  min-width: 120px !important;
}
.btn-green:hover {
  background-color: #33ca41 !important;
  box-shadow: 2px 2px 5px 0px #33ca41;
}
.btn-blue {
  background-color: #5ea6f1 !important;
  box-shadow: 2px 2px 5px 0px #5ea6f1;
  color: white !important;
  min-width: 120px !important;
}
.btn-blue:hover {
  background-color: rgba(68, 138, 255, 0.8) !important;
  box-shadow: 2px 2px 5px 0px rgba(68, 138, 255, 0.8);
}
.btn-grey {
  background-color: #c4c4c4 !important;
  box-shadow: 2px 2px 5px 0px #c4c4c4;
  color: white !important;
  min-width: 120px !important;
}
.btn-grey:hover {
  background-color: #8e8e8e !important;
  box-shadow: 2px 2px 5px 0px#8e8e8e;
}
.btn-pink {
  background-color: #ff607f !important;
  box-shadow: 2px 2px 5px 0px #ff607f;
  color: white !important;
  min-width: 120px !important;
}
.btn-pink:hover {
  background-color: #ff607f !important;
  box-shadow: 2px 2px 5px 0px #ff607f;
  color: white !important;
  min-width: 120px !important;
}
#ff607f .p-b-1 {
  padding-bottom: 1em;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}

a[href^="tel"],
button[disabled],
input[disabled],
textarea[disabled],
select[disabled] {
  cursor: not-allowed !important;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ff607f;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ff315a;
}
html,
body {
  height: 100%;
}

header {
  position: fixed;
  position: -webkit-sticky;
  top: 0; /* required */
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f1f1f1;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #f1f1f1;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #f1f1f1;
}
.wrapper {
  background: #ffffff;
}
.m-t-1 {
  margin-top: 1em;
}
.m-b-1 {
  margin-bottom: 1em;
}
.m-r-1 {
  margin-right: 1em;
}
.m-l-1 {
  margin-left: 1em;
}
.m-b-0 {
  margin-bottom: 0 !important;
}
.p-t-1 {
  padding-top: 1em !important;
}
.p-b-1 {
  padding-bottom: 1em !important;
}
.p-l-1 {
  padding-left: 1em !important;
}
.p-r-1 {
  padding-right: 1em !important;
}
.p-t-2 {
  padding-top: 2em !important;
}
.p-b-2 {
  padding-bottom: 2em !important;
}
.p-l-2 {
  padding-left: 2em !important;
}
.p-r-2 {
  padding-right: 2em !important;
}

.md-field .md-input-action {
  top: 0 !important;
  right: 4px;
  width: 20px;
  min-width: 20px;
}
.info-tooltip {
  background: #ff607f !important;
  width: 500px !important;
  white-space: normal !important;
  height: auto !important;
  overflow: visible;
  padding: 1em !important;
  border: 1px solid #ff607f !important;
}
.fa-question-circle {
  color: #ff607f;
}
.btn--filter span {
  padding-right: 0;
}
.md-disabled .md-checkbox-container {
  border-color: rgb(111 111 111 / 26%);
  background-color: #dedede !important;
  cursor: not-allowed !important;
}
.fixed-side-actions {
  position: fixed;
  bottom: 15px;
  min-width: 600px;
  background: #adadad17;
  padding: 1em !important;
  right: 10px;
}
.btn-grey-long {
  height: 43px;
  min-height: 43px;
  text-decoration: none !important;
  padding: 14px !important;
  min-width: 140px !important;
  border-radius: 3px;
  font-size: 14px !important;
  line-height: 13px !important;
}
/* 150% */
@media only screen and (min-width: 70em) and (max-width: 89em) {
  .sidebar {
    min-width: 550px;
    font-size: 11px !important;
    right: 0;
  }
  .fixed-side-actions {
    min-width: 550px;
    font-size: 11px !important;
  }
  .sidebar .sidebar__foot p {
    font-size: 12px !important;
  }
  .sidebar .sidebar__foot .blue {
    font-size: 12px !important;
  }
}
.md-theme-default a:not(.md-button) {
  /* color: red!important; */
}
</style>
